/** Strip non-digit characters and cap at `maxLength`. Use as a FormField `parse` prop. */
export function maskDigitsOnly(raw: string, maxLength: number): string {
  return raw.replace(/\D/g, '').slice(0, maxLength);
}
